import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { AppHeader } from "@/components/AppHeader";
import { MessageThread } from "@/components/MessageThread";

export default function UserMessages() {
  const { userId } = useParams();
  const [name, setName] = useState("");

  useEffect(() => {
    api.get("/users").then((r) => {
      const u = (r.data || []).find((x) => x.id === userId);
      if (u) setName(`${u.first_name || ""} ${u.last_name || ""}`.trim() || u.phone);
    }).catch(() => {});
  }, [userId]);

  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-50">
      <AppHeader title={name ? `Nachrichten · ${name}` : "Nachrichten"} back="/dashboard" />
      <main className="max-w-2xl mx-auto px-4 py-6 pb-24">
        <MessageThread scopeType="user" scopeId={userId} />
      </main>
    </div>
  );
}
